import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../Header";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import "../../styles/helpAccordion.css";
import { useSidebar } from "../../App";

export default function HelpAddUsers() {
  const { sidebarCollapsed } = useSidebar();
  const { t } = useTranslation("help");

  return (
    <div className="theme-whbl">
      <div className="container-fluid">
        <div className="main-container">
          {/* Sidebar */}

          {/* Main Content */}
          <main
            className={`${sidebarCollapsed ? "col-11" : "col-10"}`}
            style={{ width: "100%", overflowX: "auto" }}
          >
            <div className="dashboard">
              {/* Back Button */}

              {/* Page Title */}
              <div className="pm-header">
                <h1 className="pm-title">
                  {t("helpAddUsers.title", "Add User")}
                </h1>
              </div>

              {/* Help Content */}
              <div className="help-content">
                <div className="help-row">
                  <p>
                    {t(
                      "helpAddUsers.step1",
                      '1. Choose "Employees" from sidebar panel'
                    )}
                  </p>

                  <img src={t("helpAddUsers.image")} alt="Add user step 1" />
                </div>

                <div className="help-row">
                  <p>
                    {t(
                      "helpAddUsers.step2",
                      '2. Fill details and click "Add Employee" to add a new user'
                    )}
                  </p>

                  <img   src={t("helpAddUsers.image2")} alt="Add user step 2" />
                </div>
              </div>

              <div>
                <h2>
                  {t(
                    "helpAddUsers.loginSection.title",
                    "Employee Login & Verification"
                  )}
                </h2>
                <br />
                {t(
                  "helpAddUsers.loginSection.subtitle",
                  "Follow the steps below to add an employee and complete the login process."
                )}
                <br />
                <br />
                <p style={{ whiteSpace: "pre-line" }}>
                  {t(
                    "helpAddUsers.loginSection.step1",
                    "1. Admin Adds Employee\nThe admin can add an employee by entering the employee's registered email address."
                  )}
                  <br />
                  <br />
                  {t(
                    "helpAddUsers.loginSection.step2",
                    "2. Temporary Password\nOnce the employee is added, a temporary password will be sent to the registered email address."
                  )}
                  <br />
                  <br />
                  {t(
                    "helpAddUsers.loginSection.step3",
                    "3. Login with Temporary Password\nThe user can log in using their registered email address and the temporary password received by email."
                  )}
                  <br />
                  <br />
                  {t(
                    "helpAddUsers.loginSection.step4",
                    "4. OTP Verification\nAn OTP will be sent to the registered email address. Once the user enters the correct OTP, the login will be completed."
                  )}
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}